/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleIntegrationCustomerClientData
 */
export interface GoogleIntegrationCustomerClientData {
    /**
     * 
     * @type {string}
     * @memberof GoogleIntegrationCustomerClientData
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleIntegrationCustomerClientData
     */
    customerClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleIntegrationCustomerClientData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleIntegrationCustomerClientData
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleIntegrationCustomerClientData
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleIntegrationCustomerClientData
     */
    timeZone?: string;
}

/**
 * Check if a given object implements the GoogleIntegrationCustomerClientData interface.
 */
export function instanceOfGoogleIntegrationCustomerClientData(value: object): value is GoogleIntegrationCustomerClientData {
    return true;
}

export function GoogleIntegrationCustomerClientDataFromJSON(json: any): GoogleIntegrationCustomerClientData {
    return GoogleIntegrationCustomerClientDataFromJSONTyped(json, false);
}

export function GoogleIntegrationCustomerClientDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleIntegrationCustomerClientData {
    if (json == null) {
        return json;
    }
    return {
        
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'customerClientId': json['customerClientId'] == null ? undefined : json['customerClientId'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
    };
}

export function GoogleIntegrationCustomerClientDataToJSON(json: any): GoogleIntegrationCustomerClientData {
    return GoogleIntegrationCustomerClientDataToJSONTyped(json, false);
}

export function GoogleIntegrationCustomerClientDataToJSONTyped(value?: GoogleIntegrationCustomerClientData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerId': value['customerId'],
        'customerClientId': value['customerClientId'],
        'name': value['name'],
        'enabled': value['enabled'],
        'currency': value['currency'],
        'timeZone': value['timeZone'],
    };
}

